import {DataTableCellProps, TemporalFormat, tryParseInstant} from "@variocube/app-ui";
import React from "react";
import {BookingShare} from "../../../api";

export function BookingShareValidUntilCell({row}: DataTableCellProps<BookingShare>) {
	const validUntil = tryParseInstant(row.validUntil);
	return validUntil ? <TemporalFormat value={validUntil} /> : null;
}
